// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fee-schedule-program-elegibility ul>li:before{margin-left:-1.3em;margin-right:.7em;content:\"•\"}.fee-schedule-program-elegibility ol{margin-left:-0.3em;list-style:decimal}.fee-schedule-program-elegibility ol li{padding-left:3px}", ""]);
// Exports
module.exports = exports;
